var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgManOnComputer = function SvgManOnComputer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 710.99 377.92"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#aadbf9",
    d: "m698.14 238.52-21.29-5.8c.5-3.41 4.75-4.59 8.17-5l13.46-1.62c-1.06-17.53-8.47-35.55-23.54-38.24a60.2 60.2 0 0 0-17.1-.46c-.25 1.24-.49 2.48-.74 3.72a13 13 0 0 1-1.78 5.09 4.39 4.39 0 0 1-4.72 1.88c-2.36-.83-2.89-3.89-3-6.39l-.12-2.38A98.7 98.7 0 0 0 607.86 210c-1.61 1.39-3.13 3-4.66 4.51l4.62 5.84c1.23 1.56 2.54 3.5 1.9 5.38-.58 1.7-2.61 2.54-4.4 2.35a12 12 0 0 1-4.9-2.11l-4.54-2.82a45.84 45.84 0 0 0-8 18.5c-3.18 18.66 8.09 36.21 22.32 44.86a55.1 55.1 0 0 0 43.18 6c-.18-2.73-.41-5.46-.4-8.2 0-2.14.6-4.9 2.72-5.15a4.35 4.35 0 0 1 3.13 1.39 41.3 41.3 0 0 1 6.42 7.11c15.58-8.6 28.11-25.12 32.11-44 .32-1.66.57-3.4.78-5.14"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#55a8e1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M649.61 231.37c-40.93 33.76-61.45 44.56-70.8 90.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#aadbf9",
    d: "M681.77 91.53a9.36 9.36 0 0 1 4.56-.62l21.31.63a88.9 88.9 0 0 0 3-31.34c-.89-10.56-4.5-22.1-13.81-27.17-8.85-4.82-19.8-2.17-29.26 1.29-2.37.87-4.67 1.92-7 2.88 1 5.84 1.39 11.69 1.74 13.78a12.2 12.2 0 0 1 .09 5.54c-.55 1.78-2.21 3.38-4.07 3.18s-3.12-2.07-4-3.77a85 85 0 0 1-5.23-13.62 199.4 199.4 0 0 0-34.91 21.48 130 130 0 0 0-14.09 12.58c.75 1.61 1.47 3.22 2.07 4.89 1 2.81 1.57 6.46-.76 8.32-2 1.63-5.05.82-7.4-.31-1.08-.51-2-1.2-3.07-1.81a63 63 0 0 0-5.12 9.07c-6 13.3-6.43 29.81 1.87 41.81 8 11.59 22.72 17.08 36.81 17.42a79.5 79.5 0 0 0 28.5-4.62 52 52 0 0 1-.51-7.56c0-4.57.16-9.23-1.19-13.59 7.61 1.4 13.91 6.72 17.53 13.45A89 89 0 0 0 705 99.68l-20.71-2.19c-1.68-.18-3.67-.58-4.3-2.14s.4-3.12 1.78-3.82"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#55a8e1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M690 43.22a125 125 0 0 1-45.84 58.52c-9.22 6.33-14.11 8.11-27.55 19.07-48.54 39.58-37.3 20.46-35.2 256.61"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#aadbf9",
    d: "m579.32 156.36-6.57 1.69c-1.15.3-2.54.53-3.36-.33s-.37-2.58.23-3.79l3.08-6.18c-.67-.76-1.33-1.53-2-2.25a151 151 0 0 0-16.13-14.73 26.85 26.85 0 0 1-13.62 3.9 52 52 0 0 1 3.39-10.88c-2.39-1.59-4.62-3.42-7.11-4.86-6.51-3.8-14-7.19-21.35-5.61-14 3-21.4 15.56-23.82 31a13.44 13.44 0 0 1 5.29 3.12c1.61 1.76 2.23 4.66.74 6.52-1.36 1.7-3.84 1.9-6 2h-.95a94.5 94.5 0 0 0 6.57 34 38.7 38.7 0 0 0 6.46.06 8.78 8.78 0 0 1-1.3 10.61c4.78 7.95 10.82 14.11 17.91 16.85 15.9 6.13 42 2 55.61-8.06 19.16-14.18 14.22-36.06 2.93-53.06"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#55a8e1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M518.13 123.08c-6.16 10.84-1.36 24.82 6.21 34.73s17.2 18.15 24.18 28.48c26.22 38.85 32.06 38.15 32.9 191.13"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#aadbf9",
    d: "M608 309.87a44.4 44.4 0 0 0-12.77 3.91c-1.9 1-4.7 1.84-5.76 0-.85-1.47.38-3.24 1.59-4.43a50.7 50.7 0 0 1 12.5-9c-.34-.59-.66-1.2-1-1.77-7.19-11.13-17.8-19.59-28.82-26.93-6-4-12.15-7.68-18.46-11.12-1.18 1.29-2.24 2.71-3.36 4.07-1.66 2-4.15 3.76-6.68 3.17a64 64 0 0 1 4.45-10c-4.24-2.17-8.45-4.38-12.8-6.29-5.37-2.36-11.19-4.56-17-3.52-10.38 1.88-16.11 13.22-18.15 23.58a68 68 0 0 0-1.08 10.64l4.37-.21c1.54-.08 3.63.33 3.66 1.87 0 1-1 1.72-1.82 2.24l-6.12 3.66a101.55 101.55 0 0 0 13.43 44.55 35 35 0 0 1 5.11.4c2.77.44 6 1.74 6.42 4.5.34 2.16-1.31 4.21-3.27 5.18a8 8 0 0 1-.87.28A55.5 55.5 0 0 0 534.09 356c22.95 14.31 65.21 8.46 74.74-19.5 2.92-8.64 2.17-18-.83-26.63"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#55a8e1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M581.42 377.42c3.48-40-14.37-49.18-23.11-61.39-6.39-8.92-14.81-16.24-21-25.27a65.4 65.4 0 0 1-11.2-30.36"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0075c9",
    d: "M237.66 354.86c39.17-5.41 104.54-26.77 140.75-13.15s31.79 34.76 31.79 34.76H242.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0075c9",
    d: "M375.11 177.33c-26.52 10.09-28.05 32.33-38.66 77.8S306.84 360.69 311 363.6s52.48 0 52.48 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0075c9",
    d: "M423.19 145.24c70.66 37.19 93.61 55.39 93.61 55.39l-7.64 172.93H337.44s2.77-109.88 17.33-177.33c3.63-16.81 68.42-50.99 68.42-50.99"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e58e7a",
    d: "M366.53 354.86c39.18-5.41 138-31.24 174.24-17.62s-1.69 39.23-1.69 39.23h-170Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e58e7a",
    d: "M371 376.47c.7-15.9-4.43-21.61-4.43-21.61l-16.11 2.57c-18.17-10.43-26.38-15.52-37.72-9.43-15.82 8.52-30.42 14.42-27.15 16.88 4.19.1 22.26-3.81 22.26-3.81l11.21-1.31s9.75 16.69 14.06 16.69ZM385.11 169.8l12.64 4.77 64.3-4.77c-.75-2.48-2.28-5.12-3.31-7.86-3.47-9.19-21.17-42-17.54-70.29l-54 34.8a15.4 15.4 0 0 1 2.88 7.93c.78 10.35 1 26.62-4.42 34.62-.17.27-.36.54-.55.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e58e7a",
    stroke: "#a55d5d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M311.1 352.43c-12.45 7.24-23.58 11.22-17.88 12.47s29-8.85 29-8.85"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e58e7a",
    stroke: "#a55d5d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M321.94 352.43c-12.45 7.24-23.58 11.22-17.89 12.47s24.47-5.12 24.47-5.12 2.28 9.69 17.11 9.69"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e58e7a",
    d: "M245.87 376.47c.7-15.9-4.42-21.61-4.42-21.61l-16.12 2.57C207.2 347 199 341.91 187.65 348c-15.82 8.52-30.42 14.42-27.14 16.88 4.18.1 22.25-3.81 22.25-3.81l11.24-1.29s9.75 16.69 14.06 16.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e58e7a",
    stroke: "#a55d5d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M186 352.43c-12.45 7.24-23.58 11.22-17.88 12.47s29-8.85 29-8.85"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e58e7a",
    stroke: "#a55d5d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M196.85 352.43c-12.45 7.24-23.58 11.22-17.89 12.47s24.47-5.12 24.47-5.12 2.28 9.69 17.11 9.69"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d37162",
    d: "m430.88 108.55-10.6-3.42-33.07 21.32a15.4 15.4 0 0 1 2.88 7.93c.78 10.35 1 26.62-4.42 34.62-.72 1.07 4-2.47 3.2-1.43 18.43-14.3 39.86-40.79 42.01-59.02"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e58e7a",
    d: "M355.45 56.28c-12.57 26 3.13 89.09 29.33 92.19s51.89-19.67 55.2-43.58c3.79-27.33-.66-55.55-21.78-67.91s-50.02-7.05-62.75 19.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#a55d5d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M367.58 105.3c.88 2.74 1.77 5.59 1.38 8.43-.16 1.2-.55 2.35-.72 3.55-.3 2.08-1.19 3.75 1.92 4.85"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 379.96,
    cy: 99.82,
    fill: "#352269",
    rx: 2.22,
    ry: 3.87,
    transform: "rotate(-12.6 379.913 99.84)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 359.42,
    cy: 106.04,
    fill: "#352269",
    rx: 2.22,
    ry: 3.87,
    transform: "rotate(-12.6 359.378 106.054)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#352269",
    d: "M372.62 84.16c-2.34 1.41-1.38 6.94 2.5 5.61A51.6 51.6 0 0 1 390 87.21c7.07-.08 6-2.78-.53-3.71-4.72-.66-14.21-.93-16.85.66M359.91 88c3.12-.57 3 5 0 6.35s-5.47 2.74-6.24 3.84c0 0-2.64-.68-1.28-3.84a11.54 11.54 0 0 1 7.52-6.35"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0075c9",
    d: "M553.65 376.47c10-35.7-5.83-149.54-36.85-175.84s-37.34 9.42-21.5 83.63c15.44 72.37 21.5 92.21 21.5 92.21"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0075c9",
    d: "M388.41 376.47h150.67a60.8 60.8 0 0 0 12.46-11.65l-18.07-29.64c-35.31-7.36-107.2 9-149.68 16.81 1.67 7.88 3.4 17.47 4.62 24.48"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#0262a3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M387.38 352.43c17.62-3.43 109.88-28.28 134.4-19.11a51.6 51.6 0 0 1 16.31 9.42"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#0262a3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M488.16 241.8c.11 13.28 16.11 89.4 16.11 89.4M359.42 231.82c-4.5 25.41-9 123.08-9 123.08"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1b0f44",
    d: "M352.86 69.26a103 103 0 0 1-1.78 12.87s-5.08-9.34-3.18-15.06 4.96 2.19 4.96 2.19"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16.81,
    height: 10.91,
    x: 371.18,
    y: 98.75,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    rx: 4.66,
    transform: "rotate(-18.52 379.567 104.197)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16.81,
    height: 10.91,
    x: 348.69,
    y: 106.28,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    rx: 4.66,
    transform: "rotate(-18.52 357.086 111.74)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#352269",
    d: "M360.73 124.91c.09-2.8 2.71 5.29 4.08 4.2s.77-7.79 11.76-4.24S400.5 121 404.13 106c4.1-16.84 17.54-34.78 4.32-41.9s-39.76 23.8-62.27 7.64c-26.56-19.08.91-41.38 26.89-38.19 0 0 22.15-10.65 45.13 3.39s25.61 34.51 22.39 62.84c0 0-8.44 1.07-21.57-11.83 0 0-3.54 11.14 1.38 20.32s.55 34.77-15.59 40.44-45.21 8.95-44.08-23.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    d: "M364.81 108.31c2.77-3 3.06-2.82 6.55-2.19"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e58e7a",
    d: "M421.14 84c4.66-5.61 12-3 11.38 3.75s-14 14.09-14 14.09-3.62-10.32 2.62-17.84"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#a55d5d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M424.55 84.14c3.32-.44 5.34.79 5.09 2.47A11.4 11.4 0 0 1 426 93"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#0262a3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M397.75 174.57S384 281.59 383.09 315c-.45 16.71-.88 26.06-1.19 31.24M410.74 236.91c13.4.79 32.76 0 32.76 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0075c9",
    d: "m397.75 174.57 7.9-10.25 48.95-11.95 7.45 17.43zM397.75 174.57l-7.32-10.4-1.9-1.76-5.44 6.78z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#239be5",
    d: "m376.29 353.32 4.49 23.16h18.75l-7.8-13.83 6.02-13.49zM405.65 164.32 419 180.15l47.97-10.95-12.37-16.83zM390.43 164.17l-9.33 11.34-3.11-8.41 10.54-4.69zM237.66 353.32l4.49 23.16h18.74l-7.79-13.83 6.01-13.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M368.94 129.76c1.6-.57 5.47-2.38 6.72-1.17s-.58 5.58-3.45 5.49-6.72-3.08-3.27-4.32"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#aadbf9",
    d: "M136.21 365H324.8a11.47 11.47 0 0 1 11.47 11.47H136.21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#55a8e1",
    d: "M337.44 340.73H43.98L8.28 133.08h293.45z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#aadbf9",
    d: "M329.17 340.73H35.71L0 133.08h293.46z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 161.67,
    cy: 238.58,
    fill: "none",
    stroke: "#55a8e1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    rx: 16.3,
    ry: 19.35,
    transform: "rotate(-47.46 161.655 238.57)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#55a8e1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M222.46 331.31h16.92M254.17 331.31h16.92"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#55a8e1",
    d: "M223.84 376.48h-71.89l-6.14-35.75h71.88z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#55a8e1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M157.44 375.66v-7h100.69a7 7 0 0 1 7 7h0M28.59 376.47h613.53"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e2f7ff",
    d: "m300 93.76-4.89-9.38a23.72 23.72 0 0 1-1.53-17.75 60.5 60.5 0 0 0 2-16.57c.26-26.94-21-49.64-47.9-50.05a48.67 48.67 0 1 0-.68 97.33A59.4 59.4 0 0 0 266.15 94a22.73 22.73 0 0 1 13.48-.64 143 143 0 0 0 18.22 3.49 2.15 2.15 0 0 0 2.15-3.09"
  })))));
};
export default SvgManOnComputer;